import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const Goal = lazyWithPreload(() => import('./Goal'))
export const GoalVariant2 = lazyWithPreload(() => import('./GoalVariant2'))
export const LikeChatGoal = lazyWithPreload(() => import('./LikeChatGoal'))
export const GoalVariant3 = lazyWithPreload(() => import('./GoalVariant3'))
export const GoalVariant4 = lazyWithPreload(() => import('./GoalVariant4'))
